import ReactDOM from "react-dom";

import { isDOMRectInView } from "../../../Helpers/BrowserHelpers";
import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

export const FxInputTestPageObject = (
    getValue: () => string | undefined,
    autoFlag: boolean,
    disabled: boolean | undefined,
    handleRestore: () => void,
    handleChange: (value: null | undefined | string, force?: boolean) => void,
    inputDOMElement: HTMLElement | null
) => ({
    getType: () => "FxInput",
    setValue: (value: string) => {
        handleChange(value, true);
    },
    getValue: () => getValue(),
    getAutoFlag: () => autoFlag,
    restore: (): void => handleRestore(),
    isFocused: () => document.activeElement === toHtmlElementOrNull(inputDOMElement)?.querySelector("input"),
    isDisabled: (): boolean => Boolean(disabled),
    isInView: (): boolean =>
        isDOMRectInView(toHtmlElementOrNull(ReactDOM.findDOMNode(inputDOMElement))?.getBoundingClientRect()),
});
